import { render, staticRenderFns } from "./questionBase.vue?vue&type=template&id=2cf9932f&scoped=true&"
import script from "./questionBase.vue?vue&type=script&lang=js&"
export * from "./questionBase.vue?vue&type=script&lang=js&"
import style0 from "./questionBase.vue?vue&type=style&index=0&id=2cf9932f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9932f",
  null
  
)

export default component.exports